<script setup lang="ts">
    import Notification from "./Notification.vue";
    import {useNotificationStore} from "@/stores/notifications";
    const notifications = useNotificationStore();


</script>

<template>
    <div style="position: relative">
        <TransitionGroup name="list" tag="ul">
        <li class="notification" v-for="item in notifications.activeNotifications" :key="item.id">
            <Notification v-bind="item" />
        </li>
        </TransitionGroup>
    </div>
</template>

<style scoped>
.notification + .notification {
    margin-top: 0.5rem;
}

.list-move,
.list-enter-active,
.list-leave-active {
  transition: all 0.5s ease;
}

.list-enter-from,
.list-leave-to {
  opacity: 0;
}

.list-enter-from {
  transform: translateX(30px);
}

.list-leave-active {
  position: absolute;
  z-index: 1;
}
</style>